import { useNotifications } from '../../hooks/notifications/useNotifications'
import NotificationListPanel from '../../ui/notifications/NotificationListPanel'

export default function NotificationListPanelContainer({ onClose }: { onClose: () => void }) {
  const { notifications, isLoading, markAsRead, markAllAsRead } = useNotifications()

  return (
    <NotificationListPanel
      onClose={onClose}
      notifications={notifications}
      isLoading={isLoading}
      onMarkAsRead={markAsRead}
      onMarkAllAsRead={markAllAsRead}
    />
  )
}
